
export default [
  {
    id: 10,
    pic: 'https://s3.amazonaws.com/lcn-nail-spa-nc27613/images/gallery/myWork/gallery-211426.jpg'
  },
  {
    id: 9,
    pic: 'https://s3.amazonaws.com/lcn-nail-spa-nc27613/images/gallery/myWork/gallery-139504.jpg'
  },
  {
    id: 8,
    pic: 'https://s3.amazonaws.com/lcn-nail-spa-nc27613/images/gallery/myWork/1535675397_img_9639.jpg'
  },
  {
    id: 7,
    pic: 'https://s3.amazonaws.com/lcn-nail-spa-nc27613/images/gallery/myWork/1540173202_img_0208.jpg'
  },
  {
    id: 2,
    pic: 'https://s3.amazonaws.com/lcn-nail-spa-nc27613/images/gallery/myWork/1535675397_img_9639.jpg'
  },
  {
    id: 4,
    pic: 'https://s3.amazonaws.com/lcn-nail-spa-nc27613/images/gallery/myWork/gallery-213721.jpg'
  },
  {
    id: 3,
    pic: 'https://s3.amazonaws.com/lcn-nail-spa-nc27613/images/gallery/myWork/gallery-430213.jpg'
  },
  {
    id: 2,
    pic: 'https://s3.amazonaws.com/lcn-nail-spa-nc27613/images/gallery/myWork/gallery-61523.jpg'
  },
  {
    id: 2,
    pic: 'https://s3.amazonaws.com/lcn-nail-spa-nc27613/images/gallery/myWork/1535675397_img_9639.jpg'
  },


]

